export const CONSENT_COOKIE = 'idmanify_consent';
export const CONSENT_VERSION = 3;
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60;
export function readConsent(value, now = Date.now()) {
  if (
    !value ||
    typeof value !== 'object' ||
    value.version !== CONSENT_VERSION ||
    typeof value.analytics !== 'boolean' ||
    typeof value.marketing !== 'boolean' ||
    !Number.isFinite(value.updatedAt) ||
    value.updatedAt > now + 300000 ||
    now - value.updatedAt >= CONSENT_MAX_AGE * 1000
  )
    return null;
  return value;
}
export function consentRecord(choices, now = Date.now()) {
  return {
    version: CONSENT_VERSION,
    analytics: choices?.analytics === true,
    marketing: choices?.marketing === true,
    updatedAt: now
  };
}
export function googleConsent(record) {
  const valid = readConsent(record);
  return {
    analytics_storage: valid?.analytics ? 'granted' : 'denied',
    ad_storage: valid?.marketing ? 'granted' : 'denied',
    ad_user_data: valid?.marketing ? 'granted' : 'denied',
    ad_personalization: valid?.marketing ? 'granted' : 'denied',
    personalization_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted'
  };
}
export function reducedConsent(previous, next) {
  return (
    (previous?.analytics === true && next?.analytics !== true) ||
    (previous?.marketing === true && next?.marketing !== true)
  );
}
export function cleanTrackingCookies(document, hostname) {
  const names = document.cookie
    .split(';')
    .map((part) => part.trim().split('=')[0])
    .filter((name) =>
      /^(?:_ga(?:_|$)|_gid$|_gat(?:_|$)|_gcl_|_gac_|_fbp$|_fbc$)/.test(name)
    );
  const domains = [undefined];
  const labels = hostname.split('.');
  for (let i = 0; i < labels.length - 1; i++)
    domains.push(labels.slice(i).join('.'));
  for (const name of names)
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ''}`;
    }
}
// No tokens, email-prefills, order numbers, search terms or profile parameters.
export function analyticsPage(path, origin) {
  const url = new URL(path, origin);
  const segments = url.pathname.split('/').filter(Boolean);
  const locale = /^(en|de|tr|fr|es|pt|it|ar|hi|ur|ru|ja|zh)$/.test(segments[0])
    ? segments.shift()
    : 'en';
  const section = segments[0] || 'home';
  const publicSections = [
    'program',
    'post',
    'blog',
    'stories',
    'story',
    'shop'
  ];
  const safePath =
    '/' +
    (locale === 'en' ? '' : locale + '/') +
    (publicSections.includes(section)
      ? segments.map(encodeURIComponent).join('/')
      : encodeURIComponent(section));
  return {
    event: 'page_view',
    language: locale,
    page_location: new URL(safePath, origin).href,
    page_path: safePath,
    page_title: section,
    page_referrer: ''
  };
}
